export enum SalaryCertificateTypeCodes {
  TRAFIC_LICENSE = 1,
  EMBASSY = 2,
  HOSPITAL = 3,
  CID = 4,
  IMMIGRATION = 5,
  CREDIT_CARD = 6,
  LOANS = 7,
  BANK = 8,
  OTHER = 9,
}
